
export class UnidadeFederacaoModel {

        public UnidadeFederacaoId: string;
        public Nome: string;
        public NomeCapital: string;
        public DataAtualizacao: string;
        public CodigoRegiaoGeografica: number;
        public PercentualAliquotaOrigemICMS: number;
        public CodigoIBGE: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/unidade-federacao.model.ts